<template>
  <div id="app">
    <Header />
    <el-container id="container">
      <Aside />
      <el-main id="main">
        <div class="main-header">
          <Breadcrumb />
          <span
            v-if="isShowBtn"
            class="btn-back"
            @click="onBack"
          ><i class="el-icon-back" />{{ $t('back') }}</span>
          <span
            v-if="isShowBtn"
            class="btn-refresh"
            @click="onRefresh"
          ><i class="el-icon-refresh" />{{ $t('refresh') }}</span>
        </div>
        <Scrollbar
          style="height: 100%;"
          wrap-style="overflow-x: hidden;"
        >
          <!-- 滚动条移动至外面 -->
          <div class="main-content">
            <router-view :key="routeKey" />
          </div>
        </Scrollbar>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import {
  Scrollbar,
  Loading,
} from 'element-ui';
import Header from '@/components/Layout/Header';
import Aside from '@/components/Layout/Aside';
import Breadcrumb from '@/components/Layout/Breadcrumb';
import {
  mapActions,
} from 'vuex';
import roleDep from '@/utils/roleDep';
import languageDep from '@/utils/languageDep';

const loading = Loading.service({ fullscreen: true });

export default {
  components: {
    Header,
    Aside,
    Scrollbar,
    Breadcrumb,
  },
  data() {
    return {
      routeKey: 1,
    };
  },
  computed: {
    isShowBtn() {
      return this.$route.name !== 'NotFound';
    },
  },
  mounted() {
    this.init();
    this.updateNotice();
    roleDep.add('APP', this.onRoleChange);
    languageDep.add('APP', this.onRefresh);
  },
  destroyed() {
    roleDep.remove('APP');
    languageDep.remove('APP');
  },
  methods: {
    ...mapActions([
      'getUserInfo',
      'updateNotice',
    ]),
    init() {
      this.getUserInfo()
        .finally(() => {
          loading.close();
        });
    },
    onRefresh() {
      this.getUserInfo();
      this.routeKey += 1;
    },
    onBack() {
      this.$router.back();
    },
    onRoleChange() {
      const notChangeRouteName = [
        'AppDetail',
        'AppEdit',
      ];

      const routeName = this.$route.name;

      if (notChangeRouteName.indexOf(routeName) === -1) {
        this.onRefresh();
      }
    },
  },
};
</script>

<i18n>
{
  "zh": {
    "refresh": "刷新",
    "back": "返回"
  },
  "en": {
    "refresh": "Refresh",
    "back": "Back"
  }
}
</i18n>
